export default "__VITE_ASSET__Dl9nNR2M__"